import React from "react"
import { Highlight } from "shared/components"
import '../../styles/index.css';

const Table = () => {
  return (
    <table>
      <thead>
        <tr>
          <th>Category of Cookies</th>
          <th>Description</th>
          <th>Additional Information</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Essential Cookies</td>
          <td>
            Essential cookies are the basic form of memory - usually first-party
            cookies - used to store the settings selected by You on the
            Platform. As the name implies, they are essential to the Platform's
            and Content's functionality and cannot be disabled by You. For
            example, an essential cookie may be used to save You from having to
            log in each time You access a new webpage on the Platform in the
            same session.
          </td>
          <td>We use essential cookies on Platform and Content.</td>
        </tr>
        <tr>
          <td>Analytics Cookies</td>
          <td>
            When You Use Platform and / or Content, certain Third-Party Services
            generate an “anonymous analytics cookie”. These cookies tell Us
            whether You have visited Content and / or Platform before and
            analyse Your behaviour accordingly. Your browser will communicate if
            You have these cookies and, if You don’t, new ones are generated.
            This allows Us to track how many Users We have, how often they visit
            the Content and / or Platform, etc. These cookies cannot allow Us to
            identify individuals. We use them to gather statistics, for example,
            the number of visits to a page.
          </td>
          <td>
            Third-Party Services we use on Platform and Content generate
            Analytics Cookies. These include but are not limited to:
            <ul className="nested-list">
              <li className="sublist-item">
                Google Analytics: We use Google Analytics on the Platform and
                Content. Google Analytics generates statistical information
                about a website use by using cookies, which are stored on Your
                browser. The information generated relating to Platform and / or
                Content is used by Google Analytics to create reports about Use
                of Platform and / or Content. Google may store and use this
                information. Google's privacy policy is available at:
                <Highlight link={"https://policies.google.com/privacy"}>
                  &nbsp;https://policies.google.com/privacy
                </Highlight>
                <br />
                <br />
                To opt out of being tracked by Google Analytics across all
                websites, visit:
                <Highlight link="http://tools.google.com/dlpage/gaoptout">
                  &nbsp;http://tools.google.com/dlpage/gaoptout
                </Highlight>
              </li>
              <li className="sublist-item">
                Microsoft Clarity: Microsoft Clarity is a user behavior
                analytics tool that helps Us understand how Users are
                interacting with Content and / or Platform through features such
                as session replays and heatmaps. Microsoft may store and use
                this information. Microsoft's privacy policy is available at
                <Highlight link="https://privacy.microsoft.com/en-us/privacystatement">
                  &nbsp;https://privacy.microsoft.com/en-us/privacystatement
                </Highlight>
              </li>
              <li className="sublist-item">
                MoEngage: MoEngage is a user engagement platform that analyses
                behaviour of users and sends them personalized communication.
                MoEngage may store and use this information. MoEngage's privacy
                policy is available at:
                <Highlight link="https://www.moengage.com/privacy-policy/">
                  &nbsp;https://www.moengage.com/privacy-policy/
                </Highlight>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>Advertising Cookies</td>
          <td>
            These cookies may be set through Platform and /or Content by
            Advertising Partners. These cookies are used by such Third-Party
            Services to build a profile of Your interest and show You targeted
            and / or relevant advertisements. They may also be used to know
            whether You have seen an advertisement or a type of advertisement,
            and how long it is since You have seen it.
          </td>
          <td>
            We are an advertising-supported service. We partner with Third-Party
            Services to provide advertisements on Platform and / or the Content
            (“<b>Advertising Partners</b>”). These Advertising Partners collect
            certain information from the Users and use them to serve Users with
            advertisements on Platform and / or Content, and analyse which Users
            see and click on particular advertisements. Advertising Partners
            that placed Advertising cookies on the Platform and / or Content
            include, but are not be limited to, the ones listed below. Key
            policies of the Advertising Partners have been linked alongside:
            <ul>
              <li className="sublist-item">
                Google AdSense, AdX, and Ad Manager: Google will track Your
                behavior across the web using cookies and serves You relevant
                ads. You can view and edit the interests associated with Your
                browser as well as opt out of personalized advertising at:
                <Highlight link="https://adssettings.google.com/authenticated?hl=en">
                  &nbsp;https://adssettings.google.com/authenticated?hl=en
                </Highlight>
                <br />
                <br />
                However, this opt-out mechanism uses a cookie, and if You clear
                the cookies from Your browser Your opt-out will not be
                maintained. To ensure that an opt-out is maintained in respect
                of a particular browser, You should use the Google browser
                plug-in available at:
                <Highlight link="http://www.google.com/ads/preferences/plugin">
                  &nbsp;http://www.google.com/ads/preferences/plugin
                </Highlight>
                <br />
                <br />
                Privacy policy:
                <Highlight link="https://policies.google.com/privacy">
                  &nbsp;https://policies.google.com/privacy
                </Highlight>
                <br />
                <br />
                Cookie policy:
                <Highlight link="https://policies.google.com/technologies/cookies">
                  &nbsp;https://policies.google.com/technologies/cookies
                </Highlight>
              </li>
              <li className="sublist-item">
                Taboola: Privacy policy and opt-out mechanism:
                <Highlight link="https://www.taboola.com/policies/privacy-policy">
                  &nbsp;https://www.taboola.com/policies/privacy-policy
                </Highlight>
                <br />
                <br />
                Cookie policy:
                <Highlight link="https://www.taboola.com/policies/cookie-policy">
                  &nbsp;https://www.taboola.com/policies/cookie-policy
                </Highlight>
              </li>
              <li className="sublist-item">
                PubMatic: Privacy policy and opt-out mechanism:
                <Highlight link="https://pubmatic.com/legal/privacy-policy/">
                  &nbsp;https://pubmatic.com/legal/privacy-policy/
                </Highlight>
                <br />
                <br />
                Cookie policy:
                <Highlight link="https://pubmatic.com/legal/platform-cookie-policy/">
                  &nbsp;https://pubmatic.com/legal/platform-cookie-policy/
                </Highlight>
                <br />
                <br />
                We also use PubMatic's Identity Hub to centralise, test, and
                optimize alternative identity approaches. Identity Hub us an ID
                management tool for publishers and leverages specialized
                technology infrastructure in order to simplify complex
                alternative identifier market.
                <br />
                <br />
                ID partners that we use through PubMatic Identity Hub include
                but are not limited to: Criteo, LiveRamp, TTD 1.0, PubCommonID,
                ID5, Lotame You are advised to view the privacy practices and
                opt-out policies of these ID partners on their respective
                websites.
              </li>
              <li className="sublist-item">
                Amazon Publisher Services: Privacy Policy:
                <Highlight link="https://aps.amazon.com/aps/privacy-policy/">
                  &nbsp;https://aps.amazon.com/aps/privacy-policy/
                </Highlight>
                <br />
                <br />
                Cookie Policy:
                <Highlight link="https://advertising.amazon.com/legal/cookie-policy">
                  &nbsp;https://advertising.amazon.com/legal/cookie-policy
                </Highlight>
              </li>
              <li className="sublist-item">
                Index Exchange: Privacy Policy and Cookie Policy:
                <Highlight link="https://www.indexexchange.com/privacy/">
                  &nbsp;https://www.indexexchange.com/privacy/
                </Highlight>
              </li>
              <li className="sublist-item">
                OpenX: Privacy Policy and Cookie Policy:
                <Highlight link="https://www.openx.com/privacy-center/ad-exchange-privacy-policy//">
                  &nbsp;https://www.openx.com/privacy-center/ad-exchange-privacy-policy//
                </Highlight>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>Session Cookies</td>
          <td>
            Session cookies are temporary and deleted from Your machine when
            Your web browser closes.
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  );
}

export default Table
